import React, { LegacyRef } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Select from "react-select";
import "./wbmSelect.scss";
import { IWbmSelectProps } from "./wbmSelect";

export interface IOptionProps {
  className?: string;
  cx: unknown;
  getStyles: unknown;
  isDisabled: boolean;
  isFocused: boolean;
  isSelected: boolean;
  innerRef?: LegacyRef<HTMLDivElement>;
  innerProps: Record<string, unknown>;
  data: { label: string };
  options: { label: string }[];
}

const Option = (props: React.PropsWithChildren<IOptionProps>) => {
  const { children, isFocused, innerRef, innerProps, data, options } = props;
  return (
    <div
      ref={innerRef}
      className={`wbm-select-option ${isFocused ? "wso--focused" : ""}`}
      {...innerProps}
    >
      <span>{children}</span>
      {data.label !== options[options.length - 1].label && (
        <div className="wso-divider-container">
          <div className="wso-divider"></div>
        </div>
      )}
    </div>
  );
};

function WbmSelectClient(props: IWbmSelectProps) {
  const customStyles = {
    container: (provided: Record<string, unknown>) => {
      return {
        ...provided,
        zIndex: 926,
        display: "inline-block",
      };
    },
    singleValue: (provided: Record<string, unknown>) => ({
      ...provided,
      color: "#333333",
    }),
    control: (
      provided: Record<string, unknown>,
      state: Record<string, unknown>
    ) => ({
      ...provided,
      width: props.width,
      height: 40,
      boxShadow: state.isFocused
        ? "0px 0px 0px 3px rgba(232, 29, 42, 0.75)"
        : provided.boxShadow,
      border: "1px solid #dddddd !important",
    }),
    dropdownIndicator: (provided: Record<string, unknown>) => {
      const transition = "all 0.2s";
      const transform = props.dropdownIsOpen ? "rotate(-180deg)" : "rotate(0)";
      const msTransform = props.dropdownIsOpen ? "rotate(180deg)" : "rotate(0)";
      return {
        ...provided,
        paddingLeft: 1,
        paddingRight: 1,
        msTransition: transition,
        transition: transition,
        transform: transform,
        msTransform: msTransform,
        color: "#e81d2a !important",
        "& :hover": {
          color: "#e81d2a",
        },
      };
    },
    menu: (provided: Record<string, unknown>) => ({
      ...provided,
      minWidth: 188,
      marginTop: 0,
      zIndex: -1,
    }),
    menuList: (provided: Record<string, unknown>) => ({
      ...provided,
      padding: 0,
      paddingTop: 4,
    }),
    indicatorSeparator: (provided: Record<string, unknown>) => ({
      ...provided,
      marginTop: 11,
      marginBottom: 11,
      width: 1,
      height: 16,
      display: "inline-block",
    }),
  };

  return (
    <>
      <Select
        styles={customStyles}
        components={{ Option }}
        {...props}
        inputId="Category"
        name="Category"
        isSearchable={false}
        classNamePrefix="category"
        menuIsOpen={props.dropdownIsOpen && !props.forceCloseDep}
        id="Category"
      />
    </>
  );
}

export default WbmSelectClient;
